<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header></v-header>
        <!-- 产品标题 -->
        <product-tool title="X3" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="../../../assets/img/x3/pc-01.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-02.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-03.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-04.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-05.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-06.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-07.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-08.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-09.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-10.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-11.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-12.jpg"/>
        <img class="pro_img" src="../../../assets/img/x3/pc-13.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-01.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-02.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-03.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-04.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-05.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-06.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-07.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-08.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-09.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-10.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-11.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-12.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/x3/mb-13.jpg"/>
        <v-footer></v-footer>
        <goto-top></goto-top>
    </div>
</template>

<script>
export default {
    data(){
        return {
           
        }
    },
    methods:{
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/X/x3.vue